import { createApiSlice } from "@common";
import {
  CRUD_CONVERT_INQUIRY_TO_LEAD,
  CRUD_CONVERT_INQUIRY_TO_PROSPECT,
} from "@routes";

const apiConfig = [
  {
    name: "convertInquiryToLead",
    method: "post",
    url: CRUD_CONVERT_INQUIRY_TO_LEAD,
    stateKey: "message",
  },
  {
    name: "convertInquiryToProspect",
    method: "post",
    url: CRUD_CONVERT_INQUIRY_TO_PROSPECT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    loading: false,
    message: "",
  },
  reducers: {},
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "inquiryConversion",
  apiConfig,
  customReducers
);

const inquiryConversionSlice = slice;

export default inquiryConversionSlice.reducer;

export const {
  convertInquiryToLead,
  convertInquiryToProspect,
} = thunks;

